import _ from 'lodash';
import { createSelector } from 'reselect';

const usersKey="driverCitationState";

export const getDriverCitationState = (state) => _.get(state, usersKey);
export const driverCitationStateList = createSelector(getDriverCitationState, (state) => _.get(state, 'driverCitationStateList'));
export const driverCreditCardValueList = createSelector(getDriverCitationState, (state) => _.get(state, 'driverCreditCardValue'));
export const isCitationPreLoader =  createSelector(getDriverCitationState, (state) => _.get(state, 'withoutLoginPreLoader'));             


